import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ProfileImage from "../../../assets/image/employe-profile.png";
import {
  ContentLayout,
  ContentWrapper,
  ContentMenu,
  ContentForm,
  HeaderBorder,
  ProfileHeaderIocn,
  ContentBody,
  OrganizationSticky,
  ContentHeading,
  ProfileWraper,
  TtlPercentage,
} from "../../../pages/style";
import { Outlet } from "react-router-dom";
import { List, ListIcon, ListItem, ListText } from "../../../ppui/list";
import { TbBuildingBank, TbInfoOctagon, TbPencil } from "react-icons/tb";
import { EmployeeContextProvider } from "../../../context/employee-context";
import { RiExchangeFundsLine } from "react-icons/ri";
import { LuUserSquare2 } from "react-icons/lu";
import { MdOutlineWorkOutline } from "react-icons/md";
import {
  Col,
  Dialog,
  FabButton,
  Flex,
  InputField,
  Row,
  Typography,
} from "../../../ppui";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";

function MyProfile() {
  const [AboutMeEdit, setAboutMe] = React.useState(false);
  const AboutMeModalOpen = () => setAboutMe(true);
  const AboutMeModalClose = () => setAboutMe(false);

  const percentage = 65;

  const navigate = useNavigate();
  const location = useLocation();
  const menuItems = [
    {
      icon: <TbInfoOctagon />,
      primaryText: "About Me",
      path: "about-me",
    },
    {
      icon: <MdOutlineWorkOutline />,
      primaryText: "Job Description",
      path: "job-description",
    },

    {
      icon: <TbBuildingBank />,
      primaryText: "Bank Account ",
      path: "bank-account",
    },
    {
      icon: <RiExchangeFundsLine />,
      primaryText: "Nominee",
      path: "nominee",
    },
    {
      icon: <LuUserSquare2 />,
      primaryText: "Family Details ",
      path: "family-details",
    },
  ];

  return (
    <>
      <EmployeeContextProvider>
        <ContentLayout>
          <ContentHeading>
            <Typography variant="h5" mb="0">
              My Profile
            </Typography>
          </ContentHeading>
          <OrganizationSticky>
            <ContentBody Padding>
              <ProfileHeaderIocn>
                <Flex alignItem="center" gap={5}>
                  <FabButton
                    size="sm"
                    icon={<TbPencil />}
                    onClick={AboutMeModalOpen}
                    variant="filled"
                    shape="box"
                  />
                </Flex>
              </ProfileHeaderIocn>
              <Row alignItem="center">
                <Col sm={12}>
                  <Row alignItem="center">
                    <Col sm={"auto"}>
                      <ProfileWraper>
                        <CircularProgressbar
                          value={percentage}
                          strokeWidth={5}
                          styles={buildStyles({
                            pathColor: "#003f91",
                            trailColor: "#d9d9d9",
                            textColor: "#000",
                            textSize: "16px",
                            strokeLinecap: "butt",
                          })}
                        />
                        <img src={ProfileImage} alt="Login background" />

                        <TtlPercentage>65%</TtlPercentage>
                      </ProfileWraper>
                    </Col>

                    <Col sm={3}>
                      <HeaderBorder>
                        <Typography variant="h6" mb={10}>
                          Techwens software pvt ltd.
                        </Typography>
                        <Typography variant="body2">EMP524215423</Typography>
                      </HeaderBorder>
                    </Col>

                    <Col sm={2}>
                      <HeaderBorder>
                        <Typography variant="body1" mb={"0"}>
                          Contact Number
                        </Typography>
                        <Typography variant="body2" mb={"0"}>
                          +91 96523 45782
                        </Typography>
                      </HeaderBorder>
                    </Col>

                    <Col sm={2}>
                      <HeaderBorder>
                        <Typography variant="body1" mb={"0"}>
                          Email ID
                        </Typography>
                        <Typography variant="body2" mb={"0"}>
                          pankaj_kumar@gmail.com
                        </Typography>
                      </HeaderBorder>
                    </Col>

                    <Col sm={3}>
                      <Typography variant="body1" mb={"0"}>
                        Personal Email Id
                      </Typography>
                      <Typography variant="body2" mb={"0"}>
                        pankaj.saha@gmail.com
                      </Typography>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </ContentBody>
          </OrganizationSticky>

          <ContentWrapper>
            <ContentMenu>
              <List
                size={"md"}
                color={"default"}
                activeColor={"success"}
                Colorvariant={"dark"}
                hover={"secondary"}
                gap={15}
              >
                {menuItems.map((item, index) => (
                  <ListItem
                    key={index}
                    onClick={() => navigate(item.path)}
                    className={location.pathname === item.path ? "active" : ""}
                  >
                    <ListIcon>{item.icon}</ListIcon>
                    <ListText primary={item.primaryText} />
                  </ListItem>
                ))}
              </List>
            </ContentMenu>
            <ContentForm>
              <Outlet />
            </ContentForm>
          </ContentWrapper>
        </ContentLayout>
      </EmployeeContextProvider>

      <Dialog
        title="My Profile"
        closeButton={true}
        fullWidth
        maxWidth="sm"
        open={AboutMeEdit}
        onClose={AboutMeModalClose}
        separator
      >
        <Row rowGap={20}>
          <Col sm={12} md={6}>
            <InputField
              required
              fullWidth
              label="Contact Number"
              type="number"
              placeholder="Type Here"
            />
          </Col>

          <Col sm={12} md={6}>
          <InputField
              required
              fullWidth
              label="Alternative Contact Number"
              type="number"
              placeholder="Type Here"
            />
          </Col>

          <Col sm={12} md={6}>
          <InputField
              required
              fullWidth
              label="Email IF"
              type="email"
              placeholder="Type Here"
            />
          </Col>

          <Col sm={12} md={6}>
          <InputField
              required
              fullWidth
              label="Personal Email ID"
              type="email"
              placeholder="Type Here"
            />
          </Col>
        </Row>
      </Dialog>
    </>
  );
}

export default MyProfile;
